const Wishlist = {
  key: 'dashbrick_wishlist',

  get() {
    return JSON.parse(localStorage.getItem(this.key) || '[]');
  },

  save(items) {
    localStorage.setItem(this.key, JSON.stringify(items));
  },

  add(product) {
    const items = this.get();
    if (!items.find(i => parseInt(i.id) === parseInt(product.id))) {
      items.push(product);
      this.save(items);
      this.klaviyoEvent('Wishlist - Added Product', product);
    }
    this.updateButtons();
  },

  remove(id) {
    const items = this.get();
    const removed = items.find(i => parseInt(i.id) === parseInt(id));
    const newItems = items.filter(i => parseInt(i.id) !== parseInt(id));
    this.save(newItems);
    if (removed) this.klaviyoEvent('Wishlist - Removed Product', removed);
    this.updateButtons();
  },

  toggle(product) {
    this.has(product.id) ? this.remove(product.id) : this.add(product);
  },

  has(id) {
    return this.get().some(i => parseInt(i.id) === parseInt(id));
  },

  klaviyoEvent(eventName, product) {
    try {
      if (window.klaviyo) {
        window.klaviyo.push(['track', eventName, {
          ProductID: product.id,
          ProductName: product.title,
          Price: product.price,
          URL: window.location.origin + product.url,
          ImageURL: product.image,
          WishlistCount: this.get().length
        }]);
      }
    } catch(e) {}
  },

  updateButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const id = parseInt(btn.dataset.wishlistBtn);
      btn.classList.toggle('wishlisted', this.has(id));
      btn.setAttribute('aria-label', this.has(id) ? 'Remove from wishlist' : 'Add to wishlist');
    });
    this.updateCount();
  },

  updateCount() {
    const count = this.get().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  },

  init() {
  document.addEventListener('click', e => {
  const btn = e.target.closest('[data-wishlist-btn]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
      const product = {
        id: parseInt(btn.dataset.wishlistBtn),
        variant: btn.dataset.variant,
        title: btn.dataset.title,
        price: btn.dataset.price,
        url: btn.dataset.url,
        image: btn.dataset.image
      };
      this.toggle(product);
    });
    this.updateButtons();
  }
};

document.addEventListener('DOMContentLoaded', () => Wishlist.init());